// @flow
export const MIN_TARGET = 5;
export const MAX_TARGET = 32;



// WEBPACK FOOTER //
// ./src/core/constants/heating.js